/**
 * Created by yangxy on 2022/11/24.
 * 错误码
 * 后面会统一使用code,message
 */
export const ErrorCode = {
  SUCCESSFUL: { code: 0, message: 'success' },
  INVALID_PARAM: { code: 611001, message: '无效的参数' },
  INIT_FAILED: { code: 611000, message: '初始化播放器失败' },
  NOT_FOUND_FLASH: { code: 611002, message: '没有可用的flash插件' },
  ONLY_FOR_LIVE: { code: 611003, message: '此方法仅直播可用' },
  ONLY_FOR_VOD: { code: 611004, message: '此方法仅点播可用' },
  ENTER_FULLSCREEN_FAILED: { code: 611005, message: '进入全屏失败' },
  EXIT_FULLSCREEN_FAILED: { code: 611006, message: '退出全屏失败' },
  APPID_NOT_EXIST: { code: 611008, message: 'appId不存在' },
  ROOMID_NOT_EXIST: { code: 611009, message: 'roomId不存在' },
  TOKEN_NOT_EXIST: { code: 611010, message: 'token不存在' },
  RECORDID_NOT_EXIST: { code: 611011, message: 'recordId不存在' },
  BASEKS_LOAD_FAILED: { code: 611012, message: '基础SDK加载失败' },
  INIT_SERVERDATA_FAILED: { code: 611013, message: '获取接口数据处理失败' },
  INIT_CORE_FAILED: { code: 611014, message: '初始化播放器内核失败' }
};

/**
 * 用于处理上报处理参数处理
 * 因为上报数据中存在code, 上报时需要修改code->code, message->message
 * 后面考虑都统一成errcode、errmsg
 */
export function rc(ec, errDetail) {
  const errObj = {
    errcode: ec.code,
    errmsg: ec.message
  };
  if (errDetail) {
    errObj.errDetail = errDetail;
  }
  return errObj;
}

export class CustomError extends Error {
  constructor(message, defaultEC) {
    super();
    this.name = this.constructor.name;

    // level 错误级别
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }
    if (message && message.code) {
      Object.assign(this, message);
    } else if (message && typeof message === 'string') {
      Object.assign(this, { code: defaultEC.code, message: message });
    } else {
      Object.assign(this, defaultEC);
    }
  }
}

/**
 * 不合法的参数
 */
export class ValidationError extends CustomError {
  constructor(message) {
    super(message, ErrorCode.INVALID_PARAM);
  }
}
